import React from 'react';
import { useNavigate } from 'react-router-dom';

import StatusPageWrapper from './StatusPageWrapper';
import ActionButton from 'src/components/visionx/buttons/ActionButton';

export const NotFound = (): React.ReactElement => {
  const navigate = useNavigate();

  const goDashboard = () => {
    navigate('/dashboard/');
  };

  return (
    <StatusPageWrapper
      title={'Page Not Found'}
      subTitle={"Oops! We couldn't locate the page."}
      msg={
        "We're sorry, but the page you're looking for could not be found. It may have been removed, changed " +
        'its location, or never existed. Please check the URL for typos or go back to our homepage to ' +
        'explore other content.'
      }
      imgSrc={'pageNotFound'}
      errorCode={'404'}
      actionBtn={
        <ActionButton
          label="Go To Dashboard"
          action={'default'}
          icon="fa-solid fa-caret-right"
          onClick={goDashboard}
        />
      }
    />
  );
};
